import * as React from 'react';
import * as _ from 'lodash'
import { Form, Col, Row } from 'react-bootstrap';
import ButtonLoading from '../../components/ButtonLoading/ButtonLoading';
import NumberFormatValidate from '../../components/NumberFormatValidate';

interface FieldsFormQuote {
    firstName: string
    lastName: string
    email: string
    phone: string
}

export interface IFormQuoteProps {
    firstName: string
    lastName: string
    email: string
    phone: string
    company: {
        name: string
    }
    onChangeInputs(key: string, value: any): void
    submit(): Promise<void | any>
}

const FormQuote: React.FC<IFormQuoteProps> = ({ firstName, lastName, email, phone, company, onChangeInputs, submit }) => {
    const [validated, setValidated] = React.useState(false);
    const [successValidated, setSuccessValidated] = React.useState(false);
    const [btnDisabled, setBtnDisabled] = React.useState(false);
    const [clearResult, setClearResult] = React.useState(true)
    const [submitSuccess, setSubmitSuccess] = React.useState(false)
    const formRef = React.useRef(null)

    const onChangeCurrentInputs = (key: string, value: any) => {
        setValidated(true)
        setSuccessValidated(checkValidity())
        onChangeInputs(key, value)
    }

    const handleSubmit = async (): Promise<string> => {
        if (!checkValidity()) {
            throw new Error("make sure input correct data in inputs.")
        }

        return submit().then((res) => {
            if (res && res.data) {
                // setClearResult(false)
                setBtnDisabled(true)
                setTimeout(() => {
                    setSubmitSuccess(true)
                }, 2000);
                return `Thank you for your submission.  A ${company.name} representative will contact you as soon as possible.`;
            }
        }).catch((error) => {
            throw new Error(error)
        })
    }

    const checkValidity = () => {
        if (formRef) {
            let validityForm = formRef.current.checkValidity();
            return validityForm
        }
        return false
    }


    return (
        <div className=" mb-5">
            <Form noValidate validated={validated}
                ref={formRef}

                style={{ textAlign: "left" }}>
                <Row >
                    <Form.Group as={Col} md="6 mb-3" controlId="validationCustom01">
                        <Form.Label>First name</Form.Label>
                        <Form.Control
                            className="input-material"
                            required
                            type="text"
                            value={`${firstName}`}
                            onChange={(event) => onChangeCurrentInputs("firstName", event.target.value)}
                            placeholder=""

                        />
                        <Form.Control.Feedback type="invalid">
                            Valid first name is required.
                            </Form.Control.Feedback>

                    </Form.Group>
                    <Form.Group as={Col} md="6" controlId="validationCustom02">
                        <Form.Label>Last name</Form.Label>
                        <Form.Control
                            className="input-material"
                            required
                            type="text"
                            value={`${lastName}`}
                            onChange={(event) => onChangeCurrentInputs("lastName", event.target.value)}
                            placeholder=""

                        />
                        <Form.Control.Feedback type="invalid">
                            Valid last name is required.
                            </Form.Control.Feedback>

                    </Form.Group>

                </Row>
                <Row >
                    <Form.Group as={Col} md="6" controlId="formGridEmail">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                            className="input-material"
                            type="email"
                            placeholder=""
                            value={`${email}`}
                            required
                            onChange={(event) => onChangeCurrentInputs("email", event.target.value)}
                        />
                        <Form.Control.Feedback type="invalid">
                            Email is required.
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} md="6" controlId="formGridPhone">
                        <Form.Label>Phone Number</Form.Label>
                        <NumberFormatValidate
                            customInput={Form.Control}
                            className="input-material"
                            type="text"
                            defaultValue={`${phone}`}
                            value={`${phone}`}
                            onValueChange={(values) => {
                                const { formattedValue, value, floatValue } = values;
                                onChangeCurrentInputs('phone', floatValue)
                            }}

                            mask="_"
                            customValidate={(floatValue) => {
                                return _.isNumber(floatValue) && floatValue.toString().length == 10
                            }}
                            format="+1 (###) ###-####"
                            required={true}
                        />

                        <Form.Control.Feedback type="invalid">
                            Phone number is required.
                            </Form.Control.Feedback>
                    </Form.Group>

                </Row>
                {submitSuccess && <span className="text-success">Thank you for your submission.  A {company.name} representative will contact you as soon as possible.</span>}
                {successValidated && <ButtonLoading
                    clearResult={clearResult}
                    disabled={btnDisabled}
                    className="btn-primary  btn-block"
                    onClickFetching={async (e): Promise<string> => {
                        //e.stopPropagation()
                        return await handleSubmit()
                    }}>
                    Submit </ButtonLoading>}

            </Form>
        </div>
    );
}

export default FormQuote;
export { FormQuote };